import { type ReactNode, useEffect } from 'react';
import { initAirbridge } from '@banhala/utils';

export const ThirdPartyInitProvider: React.FC<{
  children: ReactNode;
}> = props => {
  useEffect(() => {
    initAirbridge();
  }, []);
  return <>{props.children}</>;
};
